function startCountdown() {
    $('.js-video-cta-play').addClass('active');
    const countdownElement = $('.js-video-play-next-count');
    let timeLeft = 3; // Start counting down from 7 seconds
    countdownElement.text(timeLeft);
    if (watchAgainCountdownIntervalId !== null) {
        clearInterval(watchAgainCountdownIntervalId);
    }
    watchAgainCountdownIntervalId = setInterval(function() {
        timeLeft--;
        countdownElement.text(timeLeft);
        if (timeLeft <= 0) {
            playNextVideo();
            clearInterval(watchAgainCountdownIntervalId);
        }
    }, 1000);
    countdownElement.text(timeLeft);
}

function stopCountdown(){
    if(watchAgainCountdownIntervalId !== null){
        clearInterval(watchAgainCountdownIntervalId);
        watchAgainCountdownIntervalId = null;
        $('.js-video-cta-play').removeClass('active');
    }
}

function playNextVideo(){
    window.location.href = nextVideosData[0].pageLink + (nextVideosData[0].pageLink.includes('?') ? '&' : '?') + 'scrollToVideoPlayer=true';
}

function convertToMilliseconds(array){
    return array.map(function(item){
        if(item.toString().includes('.')){
            const seconds = Math.floor(item);
            const milliseconds = (item - seconds) * 1000;
            return seconds * 1000 + milliseconds;
        } else {
            return parseInt(item, 10) * 1000;
        }
    });
}

// function findSmallestInPair(array1, array2) {
//     // Ensure arrays have the same length
//     const maxLength = Math.max(array1.length, array2.length);
    
//     const result = [];

//     for (let i = 0; i < maxLength; i++) {
//         let min1 = convertToMilliseconds([array1[i]]) || Infinity;
//         let min2 = convertToMilliseconds([array2[i]]) || Infinity;
//         result.push(Math.min(min1, min2));
//     }
//     return result;
// }
